import React, { Component } from "react";
import blend from "../../../media/images/blendingwhite.png";
import styles from "./BlendingLogo.module.scss";

class BlendingLogo extends Component {
  render() {
    return (
      <div
        id={styles.blend}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `url(${blend})`
        }}
      />
    );
  }
}

export default BlendingLogo;
